import React, { useCallback, useEffect, useState } from 'react';
import _ from 'lodash';
import $ from 'jquery';
// import queryString from 'stringquery';
import { connect } from 'react-redux';
import Notification, { notify } from 'react-notify-toast';
import FlipMove from 'react-flip-move';
// import { eventApi } from '../api/EventApi';
import Logger from '../util/Logger';
import NewCard from './cards/NewCard.jsx';
import Event from '../models/Event';
// import User from '../models/User';
// import { SampleEvents } from './SampleEvents';
// import { accountApi } from '../api/AccountApi';
// import { addSamples } from 'src/util/utils'
import {
  fetchEventsAndPrioritize,
  deleteEventOrPrioritizeDone,
} from '../actions/event';
import { toggleTabs, tabFilters } from './newDashboardUtils';
import LoadingAndPulse from '../components/shared/LoadingAndPulse';

import './NewCardList.css';
// : {
//   events: any,
//   selected: any,
//   handleSelected: any,
//   isDesktop: any,
//   handleCopy: any,
//   handleDelete: any,
//   handleUpdateEvents: any,
//   location: any,
//   isExampleMode: any,
//   user: any,
// }
const NewCardList = ({
  events,
  selected,
  handleSelected,
  isDesktop,
  handleCopy,
  handleDelete,
  // handleUpdateEvents,
  fetchEventsAndPrioritize,
  deleteEventOrPrioritizeDone,
  // location,
  isExampleMode,
  deleteSuccessful,
  collectionToDelete,
  // user,
  stats,
  eventsError,
  eventsLoading,
  filters = {},
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const eventsErrorText =
    'Sorry, unable to load the data for this page. If this problem persists, please contact support@popinnow.com';

  const ALL_ID = tabFilters[0].options[0].id;
  const CREATE_TOGGLE_ID = toggleTabs[0].id;

  const currentShowId =
    tabFilters[0].options.find((o) => o.id === filters.show?.id)?.id || ALL_ID;
  const currentSessionId =
    tabFilters[1].options.find((o) => o.id === filters.session?.id)?.id ||
    ALL_ID;
  const currentToggleId =
    toggleTabs.find((t) => t.id === filters.toggle?.id)?.id || CREATE_TOGGLE_ID;

  const mapFiltersToEmptyText = (currSessId) => {
    const option = tabFilters[1].options.filter((s) => s.id === currSessId)[0];

    const sessionType =
      !option?.text || option?.text === ALL_ID ? '' : option?.text;

    return {
      [toggleTabs[0].id]: {
        [tabFilters[0].options[0].id]: `YOU HAVE NO ACTIVITY YET`, //All
        [tabFilters[0].options[1].id]: `YOU HAVE NO RECENT ACTIVITY`, // Recent
        [tabFilters[0].options[2]
          .id]: `YOU HAVE NO ACTIVE ${sessionType} POPINS`, // Active
        [tabFilters[0].options[3]
          .id]: `YOU HAVE NO COMPLETED ${sessionType} POPINS`, // Completed
      },
      [toggleTabs[1].id]: {
        [tabFilters[0].options[0].id]: `YOU HAVE NO ACTIVITY YET`, //All
        [tabFilters[0].options[1].id]: `YOU HAVE NO RECENT ACTIVITY`, // Recent
        [tabFilters[0].options[2]
          .id]: `YOU ARE NOT PARTICIPATING IN ANY ACTIVE ${sessionType} POPINS`, // Active
        [tabFilters[0].options[3]
          .id]: `YOU HAVE NOT PARTICIPATED IN ANY COMPLETED ${sessionType} POPINS`, // Completed
      },
    };
  };

  const fetchEvents = () => {
    if (events && events.length > 0) {
      Logger.info('Events are fetched');
      return;
    }

    if (!isLoading) {
      setIsLoading(true);
      reallyFetchEvents();
    } else {
      reallyFetchEvents();
    }
  };

  const bindKeysToCycling = () => {
    bindKeycode(38, true); // up arrow previous
    bindKeycode(40, false); // down arrow next
  };

  const bindKeycode = (code, goToPrevious) => {
    $(document).keydown(($key) => {
      if ($key.keyCode === code) {
        if (!!events && !!selected) {
          const sortedEvents = sortEvents(events);

          let indexOfSelected = -1;
          for (let i = 0; i < sortedEvents.length; ++i) {
            const tryMe = sortedEvents[i];
            if (Event.getId(tryMe) === Event.getId(selected)) {
              indexOfSelected = i;
              break;
            }
          }

          if (indexOfSelected >= 0) {
            let selectMe;
            if (goToPrevious && indexOfSelected > 0) {
              selectMe = sortedEvents[indexOfSelected - 1];
            } else if (
              !goToPrevious &&
              indexOfSelected < sortedEvents.length - 1
            ) {
              selectMe = sortedEvents[indexOfSelected + 1];
            } else {
              selectMe = null;
            }

            if (!!selectMe) {
              keycodeSelectEvent(selectMe);
            }
          }
        }
      }
    });
  };

  const refreshEvents = () => {
    if (!isRefreshing) {
      setIsRefreshing(true);
      fetchEventsAndPrioritize();
    }
  };

  const keycodeSelectEvent = (event) => {
    handleSelected(event);
  };

  const reallyFetchEvents = () => {
    // updateEvents(events);
  };

  const sortEvents = (events) => {
    return (
      _.chain(events)
        // .filter({ 'published': true })
        .sortBy('created_time')
        .reverse()
        .value()
    );
  };

  const wrappedFetchEvents = useCallback(fetchEvents);
  const wrappedBindKeysToCycling = useCallback(bindKeysToCycling);
  const wrappedFetchEventsAndPrioritize = useCallback(fetchEventsAndPrioritize);
  const notifyCallback = useCallback(notify.show);
  const deleteDoneCallback = useCallback(deleteEventOrPrioritizeDone);

  useEffect(() => {
    wrappedFetchEvents();

    wrappedBindKeysToCycling();
  }, [wrappedBindKeysToCycling, wrappedFetchEvents]);

  useEffect(() => {
    wrappedFetchEvents();
  }, [isExampleMode, wrappedFetchEvents]);

  useEffect(() => {
    wrappedFetchEventsAndPrioritize();
  }, [wrappedFetchEventsAndPrioritize]);

  useEffect(() => {
    if (eventsError) {
      notifyCallback(eventsErrorText, 'error', 10000);
    }
  }, [eventsError, notifyCallback]);

  useEffect(() => {
    if (deleteSuccessful && collectionToDelete) {
      notifyCallback(`POPin deleted successfully`, 'success', 5000);
      deleteDoneCallback();
    }
  }, [
    deleteSuccessful,
    notifyCallback,
    collectionToDelete,
    deleteDoneCallback,
  ]);

  if (!isDesktop && !!selected) {
    return null;
  }

  const emptyText =
    mapFiltersToEmptyText(currentSessionId)[currentToggleId][currentShowId];

  if (eventsLoading) {
    return (
      <div className="col card-list empty">
        <div className="empty-card">
          <LoadingAndPulse size={10} color="#B8BAC7" whatIsLoading="activity" />
        </div>
      </div>
    );
  }

  if (events.length === 0) {
    return (
      <div className="col card-list empty">
        <div className="empty-card">{emptyText}</div>
      </div>
    );
  }

  // const dashboardEvents = sortEvents(events);
  return (
    <div
      className={`col card-list ${
        isDesktop ? 'card-list-desktop allow-scrolling' : 'card-list-mobile'
      }`}
    >
      <FlipMove staggerDurationBy="30" duration={200} typeName="div">
        {events.map((e) => (
          <div key={e.id} id={e.id}>
            <NewCard
              user={Event.getHero(e)}
              event={e}
              isLoadingStats={!stats}
              stats={stats && stats[e.id]}
              isSelected={
                !!selected ? Event.getId(selected) === Event.getId(e) : false
              }
              handleCopy={handleCopy}
              handleDelete={handleDelete}
              refreshEvents={refreshEvents}
              handleSelected={handleSelected}
            />
          </div>
        ))}
      </FlipMove>
      <Notification options={{ top: '90vh' }} />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    stats: state.event.stats,
    eventsLoading: state.event.eventsLoading,
    eventsError: state.event.eventsError,
    deleteSuccessful: state.event.deleteSuccessful,
    collectionToDelete: state.event.collectionToDelete,
  };
};

export default connect(mapStateToProps, {
  fetchEventsAndPrioritize,
  deleteEventOrPrioritizeDone,
})(NewCardList);
